import React from "react";
import { connect } from "react-redux";
import { Translate } from "react-localize-redux";
import FacebookLogin from "react-facebook-login";
import { FACEBOOK_APP_ID } from "../../app.config";
import { loginAction } from "../../redux/actions/auth.actions";

class FaceBookAuthButton extends React.Component {
  onfacebookResponse = response => {
    console.log("onfacebookResponse");
    this.props.loginAction({
      facebook: true,
      accessToken: response.accessToken
    });
  };

  componentClicked = event => console.log(event);

  render() {
    return (
      <Translate>
        {({ translate }) => (
          <FacebookLogin
            appId={FACEBOOK_APP_ID}
            autoLoad={false}
            fields="name,email,picture"
            scope="public_profile"
            onClick={this.componentClicked}
            callback={this.onfacebookResponse}
            cssClass="btn btn-block fb-button"
            icon="fab fa-facebook fb-icon"
            textButton={translate('signInWithFacebook')}
          />
        )}
      </Translate>
    );
  }
}

export default connect(
  null,
  { loginAction }
)(FaceBookAuthButton);



// WEBPACK FOOTER //
// ./src/components/FaceBookAuthButton/FaceBookAuthButton.jsx